export const archiveLinks = [
  { id: 1, date: "February 2021" },
  { id: 2, date: "January 2021" },
  { id: 3, date: "December 2020" },
];
